import { type DialogStateReturn, useDialogState } from 'reakit';

export const useDialog = (
  baseId?: string,
): {
  dialogContext: DialogStateReturn;
  hide: () => void;
  show: () => void;
  toggle: () => void;
} => {
  const dialogContext = useDialogState({ animated: true, baseId });
  const { hide, show, toggle } = dialogContext;

  return {
    dialogContext,
    hide,
    show,
    toggle,
  };
};
